import { render, staticRenderFns } from "./ExGenericBanner.vue?vue&type=template&id=38966f76&scoped=true"
import script from "./ExGenericBanner.vue?vue&type=script&lang=js"
export * from "./ExGenericBanner.vue?vue&type=script&lang=js"
import style0 from "./ExGenericBanner.vue?vue&type=style&index=0&id=38966f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38966f76",
  null
  
)

export default component.exports